import type {ReactElement} from 'react';
import {FontControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-control/font-control';
import type {LabelFontControlProps} from './label-font-control.types';

export function LabelFontControl({component}: LabelFontControlProps): ReactElement {
  return <FontControl component={component} />;
}
